import { Outlet } from "react-router-dom";

const DashboardPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default DashboardPage;
